import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import EmailVerificationBanner from './EmailVerificationBanner';
import NavbarDesktopMenu from './NavbarDesktopMenu';
import NavbarUserActions from './NavbarUserActions';
import NavbarMobileMenu from './NavbarMobileMenu';

const LOGO_SRC = 'https://customer-assets.emergentagent.com/job_heliophant-algo/artifacts/lhe7g4r4_logoHELIOPHANT.png';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t, toggleLanguage, language } = useLanguage();
  const { user, logout } = useAuth();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0e27]/80 backdrop-blur-lg border-b border-white/5">
      <EmailVerificationBanner />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src={LOGO_SRC} alt="Heliophant" className="h-10 w-auto" />
            <span className="text-2xl font-bold text-white">Heliophant</span>
          </Link>

          <NavbarDesktopMenu t={t} />

          <NavbarUserActions
            t={t}
            language={language}
            toggleLanguage={toggleLanguage}
            user={user}
            logout={logout}
          />

          {/* Mobile menu button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
            data-testid="navbar-mobile-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <NavbarMobileMenu
          t={t}
          language={language}
          toggleLanguage={toggleLanguage}
          user={user}
          logout={logout}
        />
      )}
    </nav>
  );
};

export default Navbar;
